/**
 * orga-app-api - pandemie-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EntityTypeInfo { 
    name: string;
    full_name: string;
    type_key: string;
}

